<template>
  <div class="min-h-screen bg-gradient-to-br from-psychology-calm via-white to-psychology-warm">
    <!-- 顶部导航 -->
    <nav class="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-200">
      <div class="container mx-auto px-4 py-4">
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-3">
            <router-link to="/" class="inline-flex items-center gap-2 px-3 py-2 hover:bg-gray-100 rounded-md transition-colors text-gray-600 hover:text-gray-900">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
                <path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8"></path>
                <path d="M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
              </svg>
            </router-link>
            <div class="flex items-center gap-2">
              <span class="text-2xl">💕</span>
              <span class="font-semibold text-psychology-primary">年上年下恋爱倾向测试</span>
            </div>
          </div>
        </div>

        <!-- 整体进度条 -->
        <div class="mt-4">
          <div class="flex justify-between items-center mb-2">
            <span class="text-sm text-gray-600">整体进度</span>
            <span class="text-sm font-medium">100%</span>
          </div>
          <div class="relative w-full overflow-hidden rounded-full bg-gray-200 h-2">
            <div class="h-full bg-psychology-primary transition-all duration-500" style="width: 100%;"></div>
          </div>
        </div>
      </div>
    </nav>

    <!-- 主要内容 -->
    <main class="container mx-auto px-4 py-8">
      <div class="max-w-2xl mx-auto text-center">
        <div class="card p-12">
          <div class="space-y-6">
            <!-- 动画图标 -->
            <div class="w-16 h-16 bg-psychology-primary-10 rounded-full flex items-center justify-center mx-auto">
              <span class="text-4xl animate-pulse">💖</span>
            </div>

            <!-- 标题 -->
            <div>
              <h2 class="text-2xl font-bold text-psychology-primary mb-2">正在分析您的恋爱倾向</h2>
              <p class="text-gray-600">我们正在使用科学的心理学模型计算您的AYP指数和依恋类型...</p>
            </div>

            <!-- 进度条 -->
            <div class="space-y-3">
              <div class="relative w-full overflow-hidden rounded-full bg-gray-200 h-2">
                <div class="h-full bg-purple-600 animate-progress"></div>
              </div>

              <!-- 步骤列表 -->
              <div class="space-y-2 pt-4">
                <div 
                  v-for="(step, index) in steps" 
                  :key="index"
                  class="flex items-center justify-center gap-2 text-sm transition-all duration-500"
                  :class="currentStep >= index ? 'text-gray-900' : 'text-gray-400'"
                >
                  <svg 
                    v-if="currentStep > index"
                    xmlns="http://www.w3.org/2000/svg" 
                    width="24" height="24" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor" 
                    stroke-width="2" 
                    stroke-linecap="round" 
                    stroke-linejoin="round" 
                    class="w-4 h-4 text-psychology-primary"
                  >
                    <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                    <path d="m9 11 3 3L22 4"></path>
                  </svg>
                  <svg 
                    v-else-if="currentStep === index"
                    xmlns="http://www.w3.org/2000/svg" 
                    width="24" height="24" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor" 
                    stroke-width="2" 
                    stroke-linecap="round" 
                    stroke-linejoin="round" 
                    class="w-4 h-4 text-purple-600 animate-spin"
                  >
                    <path d="M21 12a9 9 0 1 1-6.219-8.56"></path>
                  </svg>
                  <svg 
                    v-else
                    xmlns="http://www.w3.org/2000/svg" 
                    width="24" height="24" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor" 
                    stroke-width="2" 
                    stroke-linecap="round" 
                    stroke-linejoin="round" 
                    class="w-4 h-4 text-gray-300"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                  </svg>
                  <span>{{ step }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { completeSession, getSessionById } from '@/utils/sessionStorage'
import { useToast } from 'vue-toastification'

export default {
  name: 'CalculatingPage',
  setup() {
    const toast = useToast()
    return { toast }
  },
  data() {
    return {
      currentStep: 0,
      steps: [
        '计算四维度恋爱倾向分数',
        '计算AYP指数和人格类型',
        '分析依恋模式和星座特质',
        '生成个性化分析报告'
      ],
      sessionId: null
    }
  },
  mounted() {
    // 从query获取sessionId
    const sessionId = this.$route.query.sessionId
    
    if (sessionId) {
      this.sessionId = sessionId
      this.startCalculation()
    } else {
      this.toast.error('缺少会话ID')
      this.$router.push('/')
    }
  },
  methods: {
    async startCalculation() {
      try {
        if (!this.sessionId) {
          this.toast.error('会话ID缺失，请重新开始测试')
          this.$router.push('/')
          return
        }

        // 从会话获取数据
        const session = getSessionById(this.sessionId)
        if (!session) {
          this.toast.error('会话不存在，请重新开始测试')
          this.$router.push('/')
          return
        }

        // AYP测试:验证40题答案
        const answers = session.answers || []
        if (answers.length !== 40) {
          this.toast.error('答题数据不完整，请重新开始测试')
          this.$router.push('/')
          return
        }

        console.log('开始计算AYP结果，会话ID:', this.sessionId)
        
        // 模拟计算过程
        const stepInterval = setInterval(() => {
          if (this.currentStep < this.steps.length - 1) {
            this.currentStep++
          }
        }, 600)

        // 在计算过程中进行实际计算
        setTimeout(async () => {
          try {
            // 导入AYP计算工具
            const { calculateFullResult } = await import('@/utils/aypCalculator')
            
            // 使用AYP计算函数
            const result = calculateFullResult(
              answers,
              session.userInfo || {},
              session.testType
            )
            
            console.log('AYP计算完成，结果:', result)
            
            // 完成会话
            completeSession(this.sessionId, result)
            
            clearInterval(stepInterval)
            
            // 跳转到AYP结果页，传递 sessionId
            this.$router.push({
              path: '/animal-result',
              query: { 
                sessionId: this.sessionId
              }
            })
            
          } catch (error) {
            console.error('计算失败:', error)
            clearInterval(stepInterval)
            this.toast.error('计算过程中发生错误：' + error.message)
            this.$router.push('/')
          }
        }, 2400) // 2.4秒后完成计算
        
      } catch (error) {
        console.error('初始化失败:', error)
        this.toast.error('初始化失败，请重试')
        this.$router.push('/')
      }
    }
  }
}
</script>

<style scoped>
/* 进度条动画 */
@keyframes progress {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

.animate-progress {
  animation: progress 1.5s ease-in-out infinite;
  background: linear-gradient(90deg, 
    transparent 0%, 
    rgba(139, 92, 246, 0.5) 50%, 
    transparent 100%
  );
}

/* 心形图标脉冲动画 */
@keyframes pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.05);
  }
}

.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

/* 旋转动画 */
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.animate-spin {
  animation: spin 1s linear infinite;
}
</style>

